export default {
  ZH: 'Zürich',
  BE: 'Bern',
  LU: 'Luzern',
  UR: 'Uri',
  SZ: 'Schwyz',
  OW: 'Obwalden',
  NW: 'Nidwalden',
  GL: 'Glarus',
  ZG: 'Zug',
  FR: 'Freiburg',
  SO: 'Solothurn',
  BS: 'Basel-Stadt',
  BL: 'Basel-Landschaft',
  SH: 'Schaffhausen',
  AR: 'Appenzell Ausserrhoden',
  AI: 'Appenzell Innerrhoden',
  SG: 'St. Gallen',
  GR: 'Graubünden',
  AG: 'Aargau',
  TG: 'Thurgau',
  TI: 'Tessin',
  VD: 'Waadt',
  NE: 'Neuenburg',
  VS: 'Wallis',
  GE: 'Genf',
  JU: 'Jura'
}
